import { ChangeDetectionStrategy, Component, OnInit, inject, output } from '@angular/core';

import { BreakpointService } from '@shared/services/breakpoint.service';
import { EnvironmentService } from '@shared/services/environment.service';
import { MainNavService } from '../main-nav/main-nav.service';
import { FeatureFlagService } from '@app/modules/shared/services/feature-flag.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatDivider } from '@angular/material/divider';
import { UserHasScopeDirective } from '../../../authentication/user-has-scope.directive';
import { OfficeHoursComponent } from '../office-hours/office-hours.component';
import { TherapistStatusComponent } from '../therapist-status/therapist-status.component';
import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { MessageNotificationButtonComponent } from '../notifications/v1/message-notification-button/message-notification-button.component';
import { PrimaryNotificationButtonComponent } from '../notifications/v1/primary-notification-button/primary-notification-button.component';
import { GoMessageNotificationButtonComponent } from '../notifications/v2/go-message-notification-button/go-message-notification-button.component';
import { GoPrimaryNotificationButtonComponent } from '../notifications/v2/go-primary-notification-button/go-primary-notification-button.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-main-toolbar',
  templateUrl: './main-toolbar.component.html',
  styleUrl: './main-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatToolbar,
    MatDivider,
    UserHasScopeDirective,
    OfficeHoursComponent,
    TherapistStatusComponent,
    NgOptimizedImage,
    NgTemplateOutlet,
    MessageNotificationButtonComponent,
    PrimaryNotificationButtonComponent,
    GoMessageNotificationButtonComponent,
    GoPrimaryNotificationButtonComponent,
    MatIconButton,
    MatIcon,
  ],
})
export class MainToolbarComponent implements OnInit {
  private environmentService = inject(EnvironmentService);
  readonly breakpointService = inject(BreakpointService);
  readonly isMobile = this.breakpointService.matches('lt-md');
  readonly isExtraSmall = this.breakpointService.matches('xs');
  readonly isSmallOrLarger = this.breakpointService.matches('gt-xs');
  featureFlagService = inject(FeatureFlagService);
  mainNavService = inject(MainNavService);

  readonly toggleDrawer = output();

  public serverStatusMessage: string;
  public title: string;
  public isAustralia = false;

  ngOnInit(): void {
    this.title = this.environmentService.getEnvironment().dashboardTitle ?? 'Thrive Dashboard';
    this.isAustralia = this.environmentService.isAustralia();
  }
}
